import HeaderUser from "./HeaderUser";
import SidebarLogin from "../sidebar/SidebarLogin";
import SidebarActivarCuenta from "../sidebar/SidebarActivarCuenta";
import SpinnerCuadrado from "../../modules/helpers/SpinnerCuadrado";
import { useEffect, useState } from "react";
import ModalActivarCuentaSuccess from "../../modules/homeout/principal/components/modal/ModalActivarCuentaSuccess";
import ModalNewPasswordSuccess from "../../modules/homeout/principal/components/modal/ModalNewPasswordSuccess";

const HeaderMenu = (props) => {
  const [urlApi, setUrlApi] = useState("");
  const [codRecaptcha, setCodRecaptcha] = useState("");
  const [objUsuarioLogin, setObjUsuarioLogin] = useState({
    usuario: "",
    password: "",
    sitioPassword: "",
    sitioUsuario: "",
    deviceInfo: "",
    tokenCaptcha: "",
  });

  const [showMenu, setShowMenu] = useState(false);
  const [showActivaCuenta, setShowActivaCuenta] = useState(false);
  const [showModalSuccess, setShowModalSuccess] = useState(false);
  const [showModalActivaSuccess, setShowModalActivaSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const onToggleMenu = () => {
    setShowMenu(!showMenu);
  };

  const [showLogin, setShowLogin] = useState(false);

  const openLogin = () => {
    setShowMenu(!showMenu);
    setShowLogin(true);
  };

  const openActivaCuenta = () => {
    setShowMenu(!showMenu);
    setShowActivaCuenta(true);
  };

  const scrollToElement = (element) => {
    setShowMenu(false);
    const el = document.getElementById(element);
    const y = el.getBoundingClientRect().top + window.pageYOffset - 65;

    window.scrollTo({ top: y, behavior: "smooth" });
  };

  useEffect(() => {
    if (props.infoApi?.length < 1 || props.infoApi === undefined) return;
    props.infoApi?.forEach((element) => {
      setUrlApi(element.urlApi);
      setCodRecaptcha(element.cod_recaptcha);
    });
  }, [props.infoApi]);

  return (
    <>
      {loading && <SpinnerCuadrado />}

      <ModalActivarCuentaSuccess
        infoApi={props.infoApi}
        show={showModalActivaSuccess}
        close={setShowModalActivaSuccess}
        objUsuarioLogin={objUsuarioLogin}
        setLoading={setLoading}
      />

      <ModalNewPasswordSuccess
        infoApi={props.infoApi}
        show={showModalSuccess}
        setShow={setShowModalSuccess}
        setShowModalActivaSuccess={setShowModalActivaSuccess}
        setObjUsuarioLogin={setObjUsuarioLogin}
        setLoading={setLoading}
      />

      <SidebarLogin
        infoApi={props.infoApi}
        show={showLogin}
        setShow={setShowLogin}
        setShowModalSuccess={setShowModalSuccess}
        setShowModalActivaSuccess={setShowModalActivaSuccess}
        setObjUsuarioLogin={setObjUsuarioLogin}
        setLoading={setLoading}
      />

      <SidebarActivarCuenta
        urlApi={urlApi}
        codRecaptcha={codRecaptcha}
        show={showActivaCuenta}
        setShow={setShowActivaCuenta}
        setShowLogin={setShowLogin}
        setShowModalActivaSuccess={setShowModalActivaSuccess}
        setObjUsuarioLogin={setObjUsuarioLogin}
        setLoading={setLoading}
      />

      <div className="home__opciones d-none d-md-flex">
        {!props.globalAutenticado ? (
          <>
            <div onClick={() => scrollToElement("coberturas")}>
              <div className="header__opcion">TUS COBERTURAS</div>
            </div>
            <div onClick={() => scrollToElement("ecosistemas")}>
              <div className="header__opcion">TUS BENEFICIOS</div>
            </div>

            <div onClick={() => scrollToElement("siniestro")}>
              <div className="header__opcion">Reclamación de coberturas</div>
            </div>

            <div onClick={() => scrollToElement("faq")}>
              <div className="header__opcion" style={{ marginRight: "6rem" }}>
                PREGUNTAS FRECUENTES
              </div>
            </div>
          </>
        ) : (
          <HeaderUser />
        )}
      </div>
      <div className="menu__hambur d-flex d-md-none" onClick={onToggleMenu}>
        <div></div>
        <div></div>
        <div></div>
      </div>

      <div
        className={`menu__movil d-block d-md-none ${
          showMenu ? "menu__movil__show" : ""
        }`}
      >
        <div className="menu__movil__overlay">
          <div className="menu__movil__content">
            <div className="menu__movil__hambur" onClick={onToggleMenu}>
              Cerrar X
            </div>
            <div className="menu__movil__text">
              <p onClick={() => scrollToElement("coberturas")}>
                Tus coberturas
              </p>
              <p onClick={() => scrollToElement("ecosistemas")}>
                Tus beneficios
              </p>
              <p onClick={() => scrollToElement("siniestro")}>
                Reclamación de coberturas
              </p>
              <p onClick={() => scrollToElement("faq")}>FAQ's</p>
              <p onClick={openLogin}>Inicia sesión</p>
              <p onClick={openActivaCuenta}>Activa tu cuenta</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HeaderMenu;
